<template>
  <div class="time-range-filter">
    <label for="timeRangeSelect" class="filter-label">View:</label>
    <select
      id="timeRangeSelect"
      class="time-range-select"
      v-model="selectedRange"
      @change="handleRangeChange"
    >
      <option value="day">Per Day</option>
      <option value="week">Per Week</option>
      <option value="month">Per Month</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "TimeRangeFilter",
  props: {
    chartId: {
      type: String,
      required: true,
    },
    defaultValue: {
      type: String,
      default: "month",
    },
  },
  data() {
    return {
      selectedRange: this.defaultValue,
    };
  },
  methods: {
    handleRangeChange() {
      this.$emit("range-changed", {
        chartId: this.chartId,
        timeRange: this.selectedRange,
      });
    },
  },
  mounted() {
    // Set initial value
    this.selectedRange = this.defaultValue;
  },
};
</script>

<style scoped>
.time-range-filter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 0.75rem;
}

.filter-label {
  margin-right: 0.5rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: hsl(var(--muted-foreground));
}

.time-range-select {
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  border: 1px solid hsl(var(--border));
  background-color: hsl(var(--background));
  font-size: 0.9rem;
  color: hsl(var(--foreground));
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}

.time-range-select:hover {
  border-color: hsl(var(--border));
}

.time-range-select:focus {
  border-color: hsl(var(--primary));
  box-shadow: 0 0 0 2px hsl(var(--primary) / 0.2);
}
</style>
